

import React, { createContext, useEffect, useState } from 'react'
import { BASE_URL, THEME_CONFIG } from 'configs/AppConfig'
import { useSelector } from 'react-redux'
import { getAllData } from 'services/global'
import socketIOClient from "socket.io-client";
export const globalContext = createContext({})

const initialState = {}

export const GlobalProvider = ({ children }) => {
    const user = useSelector(state => state.auth.user)
    const [currentModules, setCurrentModules] = useState()
    const [listening, setListening] = useState(false)
    const [replacementListening, setReplacementListening] = useState(false)
    const fetchData = async () => {
        const { data } = await getAllData({ url: `/seq/v1/systemodulemap?systemUserId=${user.systemuserId}&status=active` })
        setCurrentModules(data)
    }
    useEffect(() => {
        const socket = socketIOClient(BASE_URL, {
          transports: ["websocket"],
        });
        socket.on("orderEvent", (data) => {
          document.getElementById('alertAudio').play();
          setListening(true)
          console.log(data)
        });
      }, []);


      useEffect(() => {
        const socket = socketIOClient(BASE_URL, {
          transports: ["websocket"],
        });
        socket.on("replacementEvent", (data) => {
          new Audio("/audio/alert.mp3").play();
          setReplacementListening(true);
        });
      }, []);



    useEffect(() => {
        if (user) {
           
            //fetchData() 
        }
        
    }, [user])

    return (
        <globalContext.Provider value={{currentModules,listening,setListening,replacementListening,setReplacementListening}}>
            {children}
        </globalContext.Provider>
    )
}
